import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-tabbed-comparison-table.scss'

export default register(`section-tabbed-comparison-table`, {
    onLoad() {
        document.querySelectorAll(`[data-section-type="section-tabbed-comparison-table"]`)
            .forEach(section => {
                section.querySelectorAll(`.tab-row .tab`).forEach(tab => {
                    tab.addEventListener(
                        `click`,
                        event => {
                            if (!(event.target.classList.contains(`active`))) {
                                section.querySelector(`.tab-row .tab.active`).classList.remove(`active`)
                                section.querySelector(`.comparison-table.active`).classList.remove(`active`)

                                event.target.classList.add(`active`)
                                section.querySelector(`#${event.target.dataset.target}`).classList.add(`active`)
                            }
                        }
                    )
                })
        })
    },
    onUnload() {

    },
})
